<div class="mat-table-global">
  <table
    [dataSource]="dataSource"
    mat-table
    matSort
    matTableResponsive
    multiTemplateDataRows
    id="site-list-table">
    <ng-container matColumnDef="accountName">
      <th mat-header-cell mat-sort-header *matHeaderCellDef>Site Name</th>
      <td mat-cell *matCellDef="let element">{{ element.accountName }}</td>
    </ng-container>

    <ng-container matColumnDef="debris">
      <th mat-header-cell mat-sort-header *matHeaderCellDef>Waste Stream</th>
      <td mat-cell *matCellDef="let element">{{ element.debris }}</td>
    </ng-container>

    <ng-container matColumnDef="accountServiceEquipment">
      <th mat-header-cell mat-sort-header *matHeaderCellDef>Equipment</th>
      <td mat-cell *matCellDef="let element">
        {{ element.accountServiceEquipment }}
      </td>
    </ng-container>

    <ng-container matColumnDef="serviceDetails">
      <th mat-header-cell mat-sort-header *matHeaderCellDef>Service Details</th>
      <td mat-cell *matCellDef="let element">
        <span [matTooltip]="element.serviceDetails" matTooltipPosition="right">
          {{ element.serviceDetails }}
        </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="serviceType">
      <th mat-header-cell mat-sort-header *matHeaderCellDef>Service Type</th>
      <td mat-cell *matCellDef="let element">{{ element.serviceType }}</td>
    </ng-container>

    <ng-container matColumnDef="serviceDays">
      <th class="action-column" mat-header-cell *matHeaderCellDef>Schedule</th>
      <td class="action-column" mat-cell *matCellDef="let element">
        <app-service-day-circles
          *ngIf="element.status !== 'On-Call'"
          [serviceDays]="[
            { displayName: 'Sun', onSchedule: element.sunday },
            { displayName: 'Mon', onSchedule: element.monday },
            { displayName: 'Tue', onSchedule: element.tuesday },
            { displayName: 'Wed', onSchedule: element.wednesday },
            { displayName: 'Thu', onSchedule: element.thursday },
            { displayName: 'Fri', onSchedule: element.friday },
            { displayName: 'Sat', onSchedule: element.saturday }
          ]"
          [isRecurringService]="element.isRecurringService"
          [recurringFrequency]="element.recurringFrequency"
          [repeat]="element.repeat"
          [repeatOn]="element.repeatOn"
          [repeatByCode]="element.repeatByCode"
          [everyWeeklySpecfiedDay]="element.everyWeeklySpecfiedDay"
          [everySpecifiedDays]="element.everySpecifiedDays"
          [everySpecifiedMonths]="element.everySpecifiedMonths"
          [dayOfWeek]="element.dayOfWeek"
          [dayOfMonth]="element.dayOfMonth"
          [monthOfYear]="element.monthOfYear"
          [everySpecifiedMonths]="element.everySpecifiedMonths">
        </app-service-day-circles>
      </td>
    </ng-container>

    <ng-container matColumnDef="action">
      <th class="action-column text-center" mat-header-cell *matHeaderCellDef>
        Action
      </th>
      <td class="action-column" mat-cell *matCellDef="let element">
        <div
          class="action-icon-container"
          (click)="siteSelected(element.customerId, element.accountId)">
          <img src="../assets/images/visibility.svg" alt="View" />
        </div>
      </td>
    </ng-container>

    <tr
      class="table-header-row"
      mat-header-row
      *matHeaderRowDef="displayedColumns"></tr>
    <tr
      class="table-data-row"
      mat-row
      *matRowDef="let row; columns: displayedColumns"></tr>
  </table>

  <mat-paginator
    class="table-paginator-row"
    [pageSizeOptions]="[10, 20, 30]"
    showFirstLastButtons></mat-paginator>
</div>
